import React from 'react';

import BaseDialog from 'core/components/base-dialog/base-dialog';
import { Label } from 'core/components/label';
import { NotificationCard } from 'core/components/notification-card';
import OfferConfiguration from './offer-configuration';
import useStyles from './offer-configuration-modal.styles';

const OfferConfigurationModal = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <BaseDialog open={open} onClose={onClose}>
      <Label type="greenBig" className={classes.title}>
        Advanced Offer Configuration
      </Label>

      <NotificationCard type="light" iconSize="icon16">
        These fields are updated outside of the normal offer edit flow. Once saved, it will be applied to this offer and
        all future variations of this offer.
      </NotificationCard>

      <div className={classes.content}>
        <OfferConfiguration />
      </div>
    </BaseDialog>
  );
};

export default OfferConfigurationModal;
